export const styles = theme => ({
  image: {
    display: "flex",
    justifyContent: "center"
  },
  logo: { width: 120, height: 60, marginBottom: 24, marginTop: 32 },
  icon: { width: 54, height: 55 }
});
